/** Delay before releasing the object URL, so the browser has started the download. */
const REVOKE_DELAY_MS = 1000;

/** Triggers a browser download of `blob` as `filename`. */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Revoking in the same tick can cancel the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
}

/**
 * Throws an `AbortError` DOMException when `signal` has been aborted -- the
 * same shape ApiClient rethrows for a cancelled request, so export handlers
 * treat a cancel that lands after the fetch (e.g. during workbook
 * serialization) exactly like one that interrupted the request.
 */
export function throwIfAborted(signal: AbortSignal): void {
  if (signal.aborted) {
    throw new DOMException('Export cancelled', 'AbortError');
  }
}
